var YOUTUBE_LINK_REGEX = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;
export function getVideoPreview(_ref) {
  var src = _ref.src;
  var srcMatch = YOUTUBE_LINK_REGEX.exec(src);
  return srcMatch ? "https://img.youtube.com/vi/".concat(srcMatch[1], "/hqdefault.jpg") : src;
}